import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import MInstalmentLogo from 'shared/images/minstallment.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const MInstalmentBanner = () => {
  const { t } = useTranslation()

  return (
    <div className={s.banner}>
      <ImageLazy
        alt=""
        src={MInstalmentLogo}
        className={s.logo}
      />

      <p className={clsx(s.title, 'semi-bold-20')}>
        {t('minstallment.banner_title')}
      </p>
    </div>
  )
}
